import http from './webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from './webhook/webhook'
import { generateAttributes } from './utils'
import {
  chatEvents,
  constantStrings,
  cookieConstant,
  eventType
} from './constants'
import { getCookie } from './cookie'

export const sendAnalyticsEvent = async (timestamp, botRefId) => {
  const data = {
    timestamp,
    eventData: {
      eventType: chatEvents.WIDGET_EVENT,
      subType: eventType.TERMS_AND_CONDITION_ACCEPTED
    }
  }
  const CUSTOM_ATTRIBUTES = generateAttributes({
    ...data,
    generatedBy: constantStrings.GENERATED_BY_SYSTEM
  })

  const requestBody = {
    triggerType: chatEvents.EVENT,
    eventData: data.eventData,
    conversationId: getCookie(cookieConstant.SESSION.CONVERSATION_ID),
    botReferenceId: botRefId,
    requestType: constantStrings.NETOMI,
    channelId: constantStrings.NETOMI_WEB_WIDGET,
    eventName: chatEvents.INFO_PILL,
    agentDesk: data.agentDesk,
    timestamp: data.timestamp,
    isPublishToMQTT: false,
    additionalAttributes: {
      CUSTOM_ATTRIBUTES
    }
  }

  await http.request({
    method: 'post',
    url: '/api/analytics/send-analytics',
    headers: generateHeaders(),
    cancelToken: cancelHTTPRequests(),
    data: { botRefId: botRefId, requestBody }
  })
}
